<h1 mat-dialog-title>Kies een adres</h1>
<mat-dialog-content>
    <p><i>U kunt dit adres later aanpassen</i></p>
    <mat-list>
        @for (adr of data.addresses; track adr) {
            <mat-list-item (click)="selectLocation(adr)">
                <div mat-line>{{ adr.formatted_address }}</div>
            </mat-list-item>
        }
    </mat-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Annuleren</button>
</mat-dialog-actions>
